var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal video-modal"},[_c('a',{staticClass:"icon-close",attrs:{"href":"javascript:;"},on:{"click":_vm.handleCloseModal}}),_c('div',{staticClass:"modal-content"},[_c('video',{ref:"videoDom",attrs:{"src":`https://${_vm.link}`,"controls":"controls","width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }